<div class="container-background container-fluid content">
  <div class="row">
    <h2 class="page-title col-12">{{ logementId ? "Modification du logement" : "Nouveau logement" }}</h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    @if (!(hasLogement | async)) {
      <div class="alert alert-info">
        Bienvenue chez vous !<br>
        Pour débuter, il vous suffit de renseigner le nom et l'adresse de votre logement.
      </div>
    }
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="save()" class="pb-4">
        <app-cover [title]="nom" [subtitle]="localite" [image]="image?.current || 'assets-front/images/logement-default.jpg'" [progress]="$safeNavigationMigration(logement?.tauxCompletude)">
          <input type="file" id="photo" class="d-none" accept="image/x-png,image/gif,image/jpeg" (change)="updatePhoto($event)"/>
          <div class="d-flex">
            @if (image?.current) {
              <a class="me-4 cursor-pointer" (click)="deletePhoto()"><fa-icon [icon]="faTrash"></fa-icon>&nbsp;<span class="d-none d-sm-inline">Supprimer</span></a>
            }
            <label for="photo" class="cursor-pointer"><fa-icon [icon]="faCloudUploadAlt"></fa-icon>&nbsp;<span class="d-none d-sm-inline">Mettre à jour</span></label>
          </div>
        </app-cover>
        <fieldset>
          <legend>Données générales</legend>
          <div class="row">
            @if (form.get('nom'); as control) {
              <div class="mb-3 col-12 col-lg-6">
                <label for="nom">Nom du logement *</label>
                <input class="form-control" id="nom" type="text" formControlName="nom" [ngClass]="{'is-invalid': !control.valid}" placeholder="Mon petit chez moi">
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('numeroFiscal'); as control) {
              <div class="mb-3 col-12 col-lg-6">
                <label for="nom">N° fiscal du local</label>
                <input class="form-control" id="numeroFiscal" type="text" formControlName="numeroFiscal" [ngClass]="{'is-invalid': !control.valid}" placeholder="N° fiscal du local">
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('typeLogement'); as control) {
              <div class="mb-3 col-12 col-lg-6">
                <label for="typeLogementPersonnalisee">Type de logement *</label>
                <select class="form-control" id="typeLogementPersonnalisee" formControlName="typeLogementPersonnalisee" [ngClass]="{'is-invalid': !control.valid}">
                  <option value="" selected="selected">Veuillez sélectionner un type...</option>
                  @for (item of $safeNavigationMigration(referentiels?.typeLogement) | keyvalue; track item) {
                    <option [value]="item.key">{{item.value}}</option>
                  }
                </select>
                <ng-template #creation>
                  <span class="form-control-plaintext">
                    <app-ref referentiel="typeLogement" [key]="control.value "></app-ref>
                  </span>
                </ng-template>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
          </div>
        </fieldset>
        <fieldset>
          <legend>Adresse</legend>
          <app-adresse #adresseComponent formControlName="adresse" [errors]="form.get('adresse').errors"></app-adresse>
        </fieldset>
        <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-bottom justify-content-center">
          <a class="btn btn-light" (click)="backClicked()">Annuler</a>&nbsp;
          <button type="submit" class="btn btn-blue" [disabled]="loaderService.loading | async">Enregistrer</button>
        </nav>
      </form>
    }
  </div>
</div>
